import React from 'react';
import { Image, Typography } from 'tfc-components';

import image from 'assets/images/home/whoweare.jpg';
import Section from 'components/organisms/Section';

const WhoWeAre: React.FC = () => (
  <Section>
    <div className="p-home_whoWeAre">
      <div className="p-home_whoWeAre_image">
        <Image imgSrc={image} alt="Who we are" ratio={411 / 309} />
      </div>
      <div className="p-home_whoWeAre_content">
        <Section.Title left small>Who We Are</Section.Title>
        <Typography.Text extendClasses="p-home_whoWeAre_text">
          EVOL LABS isn&#39;t your average tech company.
          We&#39;re a team of makers, thinkers, and technologists focused on one thing:
          <Typography.Text extendClasses="f-20x24 p-home_whoWeAre_textBold" fontweight="600">building AI-native products that matter.</Typography.Text>
        </Typography.Text>
        <Typography.Text extendClasses="p-home_whoWeAre_text">
          Born from a chance meeting between two paragliders who shared
          a love for calculated risk,
          EVOL LABS has grown into a launchpad for ideas that challenge the status quo.
        </Typography.Text>
        <Typography.Text extendClasses="p-home_whoWeAre_text">
          We build fast, test early, and aren&#39;t afraid to kill
          ideas that don&#39;t show traction.
          What we fear most is building something nobody needs.
        </Typography.Text>
      </div>
    </div>
  </Section>
);

export default WhoWeAre;
